import React from 'react'

import '../BlogPost.css'

function Post2() {
    return (
        <div className='blog-content-body'>
            <hr></hr>
            <br></br>
            <br></br>
            <div className='blog_title'><b>프롤로그</b></div>
            <div className='blog_subtitle'>부트캠프 프로젝트</div>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0/?fname=http%3A//t1.daumcdn.net/brunch/service/user/dlxY/image/qgFhgvReVLx4hWk2rODL-NEaw3k.jpg'
            width="100%"></img>
            <br></br>
            <br></br>
            <div className='article'>
            스파르타 디자이너 멤버쉽 1기로 참여해
            <br></br>부트캠프 “창”이라는 프로젝트를 진행했다.
            <br></br>
            <br></br>다양한 분야의 새로운 사람들과 무형의 프로젝트를 현실화하는건
            <br></br><b>늘 재미있는 일이다</b>
            <br></br>
            <br></br>이어서 작성 준비중
            </div>
        </div>
    )
}

export default Post2
